<template>
  <div>
    {{ $t('Custom the data fields in Shop Service.') }}
    <template v-if="setShopOption">
      <template v-if="isEdit">
        <v-layout wrap class="mb-4" v-for="(option, i) in shopOption" :key="i">
          <template v-if="option.id !== '0'">
            <h3
              class="mr-3 text-xs-right"
              style="width: 175px; margin-top: 18px!important;"
              v-if="option.id !== '3'"
            >
              {{ $t(option.label) }}
            </h3>

            <div
              class="form-control ml-4 mr-3 mt-3"
              style="display: grid;"
              :class="{ 'has-error': errors.has('text') }"
              v-else
            >
              <input
                style="margin: 0; max-width: 150px; height: 45px; font-size: 17px; text-align: right;"
                v-validate="{
                  regex: /^([ก-๛\w\s\u00C0-\u017F]{1,30})$/
                }"
                maxlength="30"
                v-model="option.label"
                name="text"
                type="text"
                :data-vv-as="$t('text')"
              />
              <span class="text-error" v-if="errors.has('text')">{{
                $t('Do not special characters.')
              }}</span>
            </div>
            <v-radio-group
              v-model="option.is_require"
              color="primary"
              name="radio"
              col
              class="text-xs-center"
            >
              <v-radio color="primary" :value="true">
                <template slot="label">
                  <span> {{ $t('Require') }}</span>
                </template>
              </v-radio>
              <div
                style="margin-left: 50px;"
                class="text-xs-center"
                v-if="option.is_require && option.id === '4'"
              >
                <v-checkbox
                  hide-details
                  class="ma-0 pa-0"
                  v-model="option.requiredNineCharacter"
                  :label="$t('Home number (fill in 9 digits)')"
                  color="primary"
                ></v-checkbox>
                <v-checkbox
                  hide-details
                  class="ma-0 pa-0"
                  v-model="option.requiredTenCharacter"
                  :label="$t('Phone number (fill in 10 digits)')"
                  color="primary"
                ></v-checkbox>
              </div>
              <v-radio color="primary" :value="false">
                <template slot="label">
                  <span> {{ $t('optional') }}</span>
                </template>
              </v-radio>
              <v-radio color="primary" :value="'close'">
                <template slot="label">
                  <span> {{ $t('Close') }}</span>
                </template>
              </v-radio>
            </v-radio-group>
          </template>
        </v-layout>
      </template>
      <template v-else>
        <v-layout class="mb-4" v-for="(option, i) in shopOption" :key="i">
          <template v-if="option.id !== '0'">
            <h3 class="pr-4 text-xs-right" style="width: 130px; margin-top: 18px!important;">
              {{ $t(option.label) }}
            </h3>
            <v-radio-group
              :value="true"
              :disabled="true"
              color="primary"
              name="radio1"
              col
              class="text-xs-center"
            >
              <v-radio color="primary" :value="true">
                <template slot="label">
                  <span>
                    {{
                      option.is_require === 'close'
                        ? $t('ปิดใช้งาน')
                        : option.is_require
                        ? $t('Require')
                        : $t('optional')
                    }}</span
                  >
                </template>
              </v-radio>
            </v-radio-group>
          </template>
        </v-layout>
      </template>
      <v-flex xs12>
        <div class="text-xs-center" style="margin-bottom: 15px;">
          <template v-if="isEdit">
            <v-btn @click="reset" outline color="grey">
              {{ $t('cancel') }}
            </v-btn>
            <v-btn @click="saveContent" depressed color="primary">
              {{ $t('Save') }}
            </v-btn>
          </template>
        </div>
      </v-flex>
    </template>
  </div>
</template>

<script>
export default {
  props: ['init', 'isEdit', 'shopOption', 'setShopOption'],
  data() {
    return {}
  },
  methods: {
    async saveContent() {
      let result = await this.$validator.validateAll()
      if (result) {
        this.$emit('onSave')
      }
    },
    reset() {
      this.$emit('onReset')
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/setting/ecommerce/ShopOption.vue